import React from 'react';

import { Block } from 'src/components/Helpers/Block';

import classes from './BranchDetailView.scss';
import { BranchDetail } from './BranchViewQuery';

type BranchDetailViewProps = {
    detail: BranchDetail;
};

export function BranchDetailView(props: BranchDetailViewProps) {
    const { detail } = props;
    return (
        <div className={classes.branchDetailsContent}>
            <h1 className={classes.branchDetailsTitle}>{detail.name}</h1>
            <Block>
                {detail.opening_hours && (
                    <>
                        <h2 className="h3">Opening Hours</h2>
                        <table className={classes.timeTable}>
                            {detail.opening_hours.map((time, index) => (
                                <tr key={`time-${index}`}>
                                    <td>{time!.day}:</td>
                                    <td className={classes.time}>{time!.time}</td>
                                </tr>
                            ))}
                            <tr>
                                <td>Bank Holidays:</td>
                                <td className={classes.time}>{detail.bank_holiday_hours}</td>
                            </tr>
                        </table>
                    </>
                )}
            </Block>
            <Block>
                <h3>Address</h3>
                {detail.address}
                <br />
                {detail.city}
                <br />
                {detail.state}
            </Block>
            <Block>
                <h4 className="h3">
                    Phone <Call telephone={detail.phone} name={detail.name} />
                </h4>
            </Block>
            <Block>
                <h5 className="h3">Services in Store</h5>
                <ul>
                    {detail.special_services.map((service, index) => {
                        return <li key={`service-${index}`}>{service}</li>;
                    })}
                </ul>
            </Block>
        </div>
    );
}

function Call(props: { telephone: string; name: string }) {
    return (
        <a href={`tel:${props.telephone}`} rel="noopener noreferrer" className={classes.phone}>
            {props.telephone}
        </a>
    );
}
